//messages.js
export default {
    notification_id: "Msg #",
    subject: "Subject",
    message: "Message",
    object_name: "Object Name",
    object_id: "Object ID",
    modal: "Notify On Login",
    non_modal: "Don't Notify On Login",
    file: "File",
    icon: "Icon",
    icon_class: "Icon Class",
    edit_notification: "Edit Notification",
    add_notification: "Add Notification",
    delete_notification: "Delete Notification",
    notifications: "Notifications",
    delete_notification_confirm: "This action is not reversible!",
    date_sent: "Date Sent",
    notify_place: "Notify",
    my_notifications: "My Notifications",
    view_notification: "Click on a notification to view it",
};
